export default class Utils {

    static possuiValor(valor) {
        return valor !== null && valor !== undefined && valor !== ''
    }
}
